/** TanStack Query hook for the admin-invite action (P1 Tier-A). */
import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import {
  createInvitation,
  type InvitationCreate,
  type InvitationResponse,
} from "@/features/admin/invitations/api";

export function useCreateInvitation(): UseMutationResult<
  InvitationResponse,
  Error,
  InvitationCreate
> {
  return useMutation<InvitationResponse, Error, InvitationCreate>({
    mutationFn: (body) => createInvitation(body),
  });
}
